import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Filter from './Filter'; // Riusiamo il componente per l'input

function FilterModal({
  show,
  handleClose,
  table,
  columnsToFilter,
}) {
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Imposta Filtri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {columnsToFilter.length > 0 ? (
          columnsToFilter.map(columnId => {
            const column = table.getColumn(columnId);
            if (!column) return null;
            return (
              <div key={columnId} className="mb-3">
                <label className="fw-bold">{column.columnDef.header}</label>
                <Filter column={column} />
              </div>
            );
          })
        ) : (
          <p>Nessuna colonna selezionata per il filtraggio.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Chiudi
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FilterModal;
